import React, { useState } from "react";
import "./ad.css";
import { msgPromtsuccess } from "../../features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { add_fund_request } from "../../features/userSlice";
const PaymentComponent = () => {
  const [amount, setAmount] = useState("");
  const [utr, setUtr] = useState("");
  const dispatch = useDispatch();
  const { Info } = useSelector((state) => state.users);


  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    dispatch(msgPromtsuccess({msg:`${text} copied to clipboard!`,error:false}));
   // alert(`${text} copied to clipboard!`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let data = new FormData();
    data.append('phone_number',Info?.phone_number);
    data.append('amount', amount);
    data.append('UTR_NUM',utr );
    dispatch(add_fund_request(data));
  };

  return (
    <div className="payment-container">
      {/* Frosted Glass Effect Scanner Section */}
      <div className="scanner-section">
        <div className="frosted-glass">
          <img
            src="home/images/scanner.jpeg"
            alt="Scanner"
            className="scanner-image"
          />
        </div>
      </div>

      {/* PhonePe and Google Pay Details */}
      <div className="payment-container centerFlex">
      <div className="payment-details ">
        <h3>PhonePe / Google Pay Numbers</h3>
        <div className="number-container">
          <div className="number-item">
            <span>7852058306</span>
            <button onClick={() => handleCopy("7852058306")} className="copy-btn">
              Copy
            </button>
          </div>
          <div className="number-item">
            <span>7852058306</span>
            <button onClick={() => handleCopy("7852058306")} className="copy-btn">
              Copy
            </button>
          </div>
        </div>
      </div>
      </div>
      {/* Payment Form */}
      <div className="payment-container centerFlex">
      <div className="payment-form">
        <h3>Submit Payment Details</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="amount">Payment Amount</label>
            <input
              type="number"
              id="amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
              placeholder="Enter payment amount"
            />
          </div>
          <div className="form-group">
            <label htmlFor="utr">UTR Number</label>
            <input
              type="text"
              id="utr"
              value={utr}
              onChange={(e) => setUtr(e.target.value)}
              required
              placeholder="Enter UTR number"
            />
          </div>
          <button type="submit" className="submit-btn">Submit</button>
        </form>
      </div>
    </div>
    </div>
  );
};

export default PaymentComponent;
